module.exports = __webpack_public_path__ + "img/banner1.b7b231f.png";